import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import palceholderimage from "../../../assets/images/palceholderimage.webp";
import NeverWorn from "../../../assets/images/HomePage/never_worn.webp";
import NewIn from "../../../assets/images/HomePage/new_in.webp";
import PriceDrops from "../../../assets/images/HomePage/price_drops.webp";
import Vintage from "../../../assets/images/HomePage/vintage_2.webp";
import { useDispatch } from "react-redux";
import { SetSearch } from "../../../features/TopSearches/TopSearchesSlice";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  SetSelectdPage,
  SetSizeFilter,
  SetTopSizeFilter,
  SortProducts,
  SetBottomSizeFilter,
  resetLoadingNumber,
  getAllProductOnline,
} from "../../../features/Products/ProductSlice";
import { LazyLoadImage } from "react-lazy-load-image-component";
// import women from "../../../assets/images/HomePage/women2.webp";
// import womenphone from "../../../assets/images/HomePage/womenphone2.webp";
// import watch from "../../../assets/images/HomePage/watch2.webp";
// import watchphone from "../../../assets/images/HomePage/watch2phone.webp";
import womend from "../../../assets/images/HomePage/wd.webp";
import womenp from "../../../assets/images/HomePage/wp.webp";
import watchd from "../../../assets/images/HomePage/wtd.webp";
import watchp from "../../../assets/images/HomePage/wtp.webp";
import { position } from "@chakra-ui/react";

function ImageSection() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [imageLoaded, setImageLoaded] = useState(false);

  if (i18n.language == "ar") {
    var arabStyle = {
      letterSpacing: "0em",
    };
  } else {
    var arabStyle = {};
  }

  return (
    <>
      <div
        className={`row px-md-5 px-0   ${
          i18n.language == "en" ? "ms-0 me-0 " : `me-0 ms-0`
        }`}
        id="style-2"
      >
        {/* for desktop */}
        <div
          className="row d-md-flex d-none px-0 gx-4"
          style={{
            width: "100%",
            height: "100%",
            position: "relative",
            height: "20vw",
          }}
        >
          <div
            className="col-md-6 position-relative"
            style={{ backgroundColor: "#FBF5F0" }}
          >
            {/* The image is positioned absolutely to the right */}
            <img
              className={`position-absolute ${
                i18n.language === "ar" ? "start-0" : "end-0"
              } top-50 translate-middle-y d-none d-md-block`}
              src="/womenlatest.webp"
              alt="Women"
              style={{
                width: "auto",
                height: "100%",
                zIndex: 1,
              }}
            />

            <img
              src="/mobilebottom.png"
              alt="Women"
              style={{
                height: "100%",
                position: "absolute",
                bottom: "0",
                left: "0",
                right: "0",
                zIndex: 0,
              }}
            />
            {/* main text container */}
            <div
              className=" py-4 montserrat-font"
              style={{
                paddingLeft: "25px",
                paddingTop: "25px",
              }}
            >
              <div className="image-title">
                {new Date().getFullYear()} {t("ImageTitle-1")}
              </div>
              <div className="image-subtitle">{t("ImageSubTitle-1")}</div>
              <button
                className={`btn-2Image ${
                  i18n.language === "en" ? "me-2" : "ms-2"
                }`}
                style={{
                  border: "1px solid #808080 ",
                  color: "#808080",
                }}
                onClick={() => {
                  navigate("/products?gender=WFA967se7qX0jYtySgTj");
                  window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
                }}
              >
                {t("exp4")}
              </button>
            </div>
          </div>
          <div
            className="col-md-6 position-relative "
            style={{
              position: "relative",
              backgroundColor: "#FAFAFA",
              left: "20px",
            }}
          >
            {/* The image is positioned absolutely to the right */}
            <img
              className={`position-absolute ${
                i18n.language === "ar" ? "start-0" : "end-0"
              } top-50 translate-middle-y d-none d-md-block`}
              src="/watchlatest.webp"
              alt="Watch"
              style={{
                width: "auto",
                height: "100%",
                zIndex: 1,
              }}
              onClick={() =>
                navigate(
                  "/products?subcategory=kYTvn5wAxopx5jpqotC0&gender=KG3s4pPk3arcBux5ERnD&"
                ) & window.scrollTo({ top: 0, left: 0, behavior: "instant" })
              }
            />

            {/* main text container */}
            <div
              className=""
              style={{
                paddingLeft: "25px",
                paddingTop: "25px",
              }}
            >
              <div className="image-title">{t("watchheading1")}</div>
              <div className="image-subtitle">{t("watchheading2")}</div>
              <button
                className={`btn-2Image ${
                  i18n.language == "en" ? "me-2" : "ms-2"
                }`}
                style={{
                  border: "1px solid #808080 ",
                  color: "#808080",
                }}
                onClick={() =>
                  navigate(
                    "/products?subcategory=kYTvn5wAxopx5jpqotC0&gender=KG3s4pPk3arcBux5ERnD&"
                  ) & window.scrollTo({ top: 0, left: 0, behavior: "instant" })
                }
              >
                {t("exp4")}
              </button>
            </div>
          </div>
        </div>
        {/* for mobile */}
        <div
          className="row d-md-none d-flex px-0 justify-content-center montserrat-font"
          style={{
            marginLeft: "1px",
            marginRight: "1px",
            width: "100%",
            position: "relative",
          }}
        >
          <div
            style={{ backgroundColor: "#FBF5F0" }}
            className={`col-12 d-flex ${
              i18n.language === "ar" ? "flex-row-reverse" : "flex-row-reverse"
            } align-items-center position-relative`}
          >
            <img
              src="/womenlatest.webp"
              alt="Women"
              style={{
                width: "40%",
                height: "100%",
                zIndex: 1,
              }}
            />
            <img
              src="/mobilebottom.png"
              alt="Women"
              style={{
                height: "100%",
                position: "absolute",
                bottom: "0",
                left: "0",
                right: "0",
                zIndex: 0,
              }}
            />
            <div
              className={`${i18n.language !== "ar" ? "image-container" : ""}`}
              style={{ width: "70%", paddingTop: "15px", zIndex: 1 }}
            >
              <div
                className="image-title"
                style={{ fontSize: "14px", fontWeight: "400" }}
              >
                {new Date().getFullYear()} {t("ImageTitle-1")}
              </div>
              <div
                className="montserrat-font"
                style={{ fontSize: "16px", fontWeight: "500" }}
              >
                {t("ImageSubTitle-1")}
              </div>
              <button
                className={`btn-2Image ${
                  i18n.language == "en" ? "me-2" : "ms-2"
                }`}
                style={{
                  border: "1px solid #808080 ",
                  color: "#808080",
                }}
                onClick={() =>
                  navigate(
                    "/products?subcategory=kYTvn5wAxopx5jpqotC0&gender=KG3s4pPk3arcBux5ERnD&"
                  ) & window.scrollTo({ top: 0, left: 0, behavior: "instant" })
                }
              >
                {t("exp4")}
              </button>
            </div>
          </div>

          <div
            style={{ backgroundColor: "#FCFCFC" }}
            className={`col-12 mt-4 d-flex ${
              i18n.language === "ar" ? "flex-row-reverse" : "flex-row-reverse"
            } align-items-center position-relative`}
          >
            <img
              src="/watchlatest.webp"
              alt="watch"
              style={{ width: "40%", height: "100%" }}
            />
            <div
              className={`${i18n.language !== "ar" ? "image-container" : ""}`}
              style={{ width: "70%", paddingTop: "15px" }}
            >
              <div
                className="image-title"
                style={{ fontSize: "14px", fontWeight: "400" }}
              >
                {t("watchheading2")}
              </div>
              <div
                className="image-subtitle"
                style={{ fontSize: "16px", fontWeight: "400" }}
              >
                {t("watchheading2")}
              </div>
              <button
                className={`btn-2Image ${
                  i18n.language == "en" ? "me-2" : "ms-2"
                }`}
                style={{
                  border: "1px solid #808080 ",
                  color: "#808080",
                }}
                onClick={() =>
                  navigate("/products?subcategory=kYTvn5wAxopx5jpqotC0") &
                  window.scrollTo({ top: 0, left: 0, behavior: "instant" })
                }
              >
                {t("exp4")}
              </button>
            </div>
          </div>
        </div>
      </div>

      <br></br>
    </>
  );
}

export default ImageSection;
